import { CodeTypeValue, CodeTypeRequest } from './codetypevalue.interface';
import { AppData } from '../../models/appdata'
import { Injectable, Inject, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { Observable, throwError, of } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ApiResponseModel } from '../../models/api_response_model';

@Injectable()
export class CodeTypeValueService {

  codeTypeValue: CodeTypeValue[];

  constructor(private http: HttpClient,
    private injector: Injector, private router: Router)
    {
 
    }
  GetCodeValuesByType(SendCodeTypeRequest: CodeTypeRequest) {
  
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}MasterData/GetCodeValuesByType`, (SendCodeTypeRequest),
       {
            headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY),
          }
        ).pipe(catchError(this.handleError));
    }

  private handleError(error: any) {


    if (error.status === 400) {

      return Promise.reject('Request Failed Due to Bad Request..!');
    }
    else if (error.status === 401) {
      return this.unauthorised();

    }
    else if (error.status === 500) {
      return Promise.reject('Internal Server Error..!');

    }
    else {


      let errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
      return Promise.reject(error.message || error);
    }
  }
  unauthorised(): Observable<any> {

    this.router.navigate(['/login']);
    return of({});
  }

}
